import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      common: {
        save: 'Save',
        undo: 'Undo',
        settings: 'Settings',
        help: 'Contact Support',
        feedback: 'Share Feedback',
        back: 'Back',
        options: 'Options',
        prevPage: 'Previous page',
        nextPage: 'Next page',
        runLog: 'Run Log',
        search: 'Search',
        module: 'Module',
        state: 'State',
        junction: 'Junction',
        childWorkflow: 'Child Workflow',
        ok: 'OK',
        cancel: 'Cancel',
        leave: 'Leave',
        output: 'Output',
        copyToClipboard: 'Copy to Clipboard',
        'Run Child Workflow': 'Run child workflow',
        trigger: 'Trigger',
      },
      exitconfirrmmodal: {
        title: 'Unsaved changes',
        message:
          'There are unsaved changes on this workflow. Leaving without saving will revert the workflow to the last saved instance.',
      },
      designer: {
        title: 'Designer',
        canvas: {
          dropTargetPlaceholder: 'Drop to add new module',
          moveTargetPlaceholder: 'Drop to move module',
          removestate: 'Remove state',
          removemodule: 'Remove module',
          removejunction: 'Remove junction',
          removegroup_junction: 'Remove group',
          removegroup_exit: 'Remove group exit',
          removechild: 'Remove child workflow',
        },
        addModule: {
          custom: 'Custom Build Integrations & Utilities',
          integrations: 'All Integrations',
          noSearchResults: 'There are no results found.',
          pinned: 'Pinned',
          utilities: 'All Utilities',
          newState: 'New State',
          newChild: 'New Child Workflow',
          newJunction: 'New Junction',
        },
        topRail: {
          settings: 'Workflow Settings',
          switchToLegacyView: 'Switch to legacy view',
        },
        rightRail: {
          addModule: 'Add Module',
          chat: 'Chat',
          editModule: 'Edit Module',
        },
        runLog: {
          refresh: 'Refresh',
          timestamp: 'Filter By Date',
          runWorkflow: 'Run workflow',
          filterByState: 'Filter By Workflow State',
          runningInProgress: 'Running...',
          runningFilter: 'Running',
          waiting: 'Waiting',
          stoppedByError: 'Stopped By Error',
          stopped: 'Stopped',
          completed: 'Completed',
          all: 'All',
          viewAllRuns: 'View all runs',
          runDuration: 'Run Duration',
          expand: 'Expand',
          collapse: 'Collapse',
          kebabMenu: {
            menuArialabel: 'Run log menu',
            copyDataRef: 'Copy Data Reference',
            copyJSONSource: 'Copy JSON Source',
          },
        },
        triggerPanel: {
          integrations: {
            tabName: 'Integrations',
            title: 'Under construction',
            subtitle:
              'Create a trigger from applications on the Integrations page.',
            text: 'To see or manage triggers go back to the',
            legacyView: 'Legacy View',
            button: 'Open integrations',
          },
          schedules: {
            tabName: 'Schedules',
            noSchedules: 'There are no schedules added yet.',
            addNewSchedule: 'Add new schedule',
            schedule: 'Schedule',
            every: 'Every',
            runOptions: {
              once: 'Once',
              hourly: 'Hourly',
              daily: 'Daily',
              weekly: 'Weekly',
              monthly: 'Monthly',
              yearly: 'Yearly',
              custom: 'Custom',
            },
            unitOptions: {
              minutes: 'Minutes',
              hours: 'Hours',
              days: 'Days',
              weeks: 'Weeks',
              months: 'Months',
              years: 'Years',
            },
            deleteModal: {
              title: 'Delete schedule',
              description:
                'Deleting a schedule may prevent your workflow from running.',
            },
            list: {
              activeSchedules: 'Active schedules',
              frequency: 'Frequency',
              startTime: 'Start time',
              nextRun: 'Next run',
              edit: 'Edit',
              delete: 'Delete',
            },
            upsert: {
              startDate: 'Start date (UTC)',
              startTime: 'Start time (UTC)',
              run: 'Run',
              runTimeNotice:
                'Run times are estimated and may vary by up to 15 minutes.',
              everyInteger:
                'Field must contain an integer / whole number bigger than 0',
              everyMinimum1: 'Enter a minimum of 1',
              everyMinutes: 'Enter a minimum of 15 minutes',
              unit: 'Unit',
              unitLabel: 'Select the unit of time to repeat',
              required: 'Field requires a value',
              runOnLastDayOfMonth: 'Run on last day of the month',
              runOnLastDayOfMonthInfo:
                'By leaving this box unchecked, schedules will skip all months where the day does not exist.',
              areRequiredFields: 'are required fields',
              isArequiredFeild: 'is a required field',
              startTimePast: 'Start time cannot be in the past',
              startDatePast: 'Start date cannot be in the past',
              currentUTC: 'Current UTC',
            },
          },
          parentWorkflow: {
            tabName: 'Parent workflows',
            title: 'Parent workflows',
            noWorkflows:
              'There are no parent workflows triggering this workflow.',
            instructions: 'Learn how to use parent workflow as a trigger',
          },
        },
      },
      signin: {
        title: 'Sign In - Bridge by Smartsheet',
        signinToBridge: 'Sign in to Bridge.',
        signinWithSmartsheet: 'Sign in with Smartsheet',
        signinWithBridge: 'Sign in with Bridge Credentials',
        email: 'Email',
        password: 'Password',
        signin: 'Sign In',
        resetPassword: 'Forgot your password?',
        termsOfUse:
          'By continuing, you agree to the <1>Terms of Use</1>. Our <3>Privacy Policy</3> describes how we process personal data.',
        validationMessage:
          'Email address or password are incorrect. Please try again or reset your password.',
        unableToSignin: 'Unable to login',
        unableToSigninDescription:
          'Unable to log in with Smartsheet credentials at this time. Please ensure you are attempting to access via the correct URL and that you have been added to this Bridge account by your Bridge SysAdmin. You can also',
      },
      timesPerFormat: {
        24: {
          '0000': '00:00',
          '0015': '00:15',
          '0020': '00:20',
          '0045': '00:45',
          '0100': '01:00',
          '0115': '01:15',
          '0130': '01:30',
          '0145': '01:45',
          '0200': '02:00',
          '0215': '02:15',
          '0230': '02:30',
          '0245': '02:45',
          '0300': '03:00',
          '0315': '03:15',
          '0330': '03:30',
          '0345': '03:45',
          '0400': '04:00',
          '0415': '04:15',
          '0430': '04:30',
          '0445': '04:45',
          '0500': '05:00',
          '0515': '05:15',
          '0530': '05:30',
          '0545': '05:45',
          '0600': '06:00',
          '0615': '06:15',
          '0630': '06:30',
          '0645': '06:45',
          '0700': '07:00',
          '0715': '07:15',
          '0730': '07:30',
          '0745': '07:45',
          '0800': '08:00',
          '0815': '08:15',
          '0830': '08:30',
          '0845': '08:45',
          '0900': '09:00',
          '0915': '09:15',
          '0930': '09:30',
          '0945': '09:45',
          '1000': '10:00',
          '1015': '10:15',
          '1030': '10:30',
          '1045': '10:45',
          '1100': '11:00',
          '1115': '11:15',
          '1130': '11:30',
          '1145': '11:45',
          '1200': '12:00',
          '1215': '12:15',
          '1230': '12:30',
          '1245': '12:45',
          '1300': '13:00',
          '1315': '13:15',
          '1330': '13:30',
          '1345': '13:45',
          '1400': '14:00',
          '1415': '14:15',
          '1430': '14:30',
          '1445': '14:45',
          '1500': '15:00',
          '1515': '15:15',
          '1530': '15:30',
          '1545': '15:45',
          '1600': '16:00',
          '1615': '16:15',
          '1630': '16:30',
          '1645': '16:45',
          '1700': '17:00',
          '1715': '17:15',
          '1730': '17:30',
          '1745': '17:45',
          '1800': '18:00',
          '1815': '18:15',
          '1830': '18:30',
          '1845': '18:45',
          '1900': '19:00',
          '1915': '19:15',
          '1930': '19:30',
          '1945': '19:45',
          '2000': '20:00',
          '2015': '20:15',
          '2030': '20:30',
          '2045': '20:45',
          '2100': '21:00',
          '2115': '21:15',
          '2130': '21:30',
          '2145': '21:45',
          '2200': '22:00',
          '2215': '22:15',
          '2230': '22:30',
          '2245': '22:45',
          '2300': '23:00',
          '2315': '23:15',
          '2330': '23:30',
          '2345': '23:45',
        },
      },
      dateFormat: {
        monthFirst: 'mm/dd/yyyy',
        dayFirst: 'dd/mm/yyyy',
      },
      timeFormat: {
        HHMM: 'HH:MM',
        at: 'at',
      },
    },
  },
  fallbackLng: 'en',
  debug: false,
  lng: 'en',

  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
});

export default i18n;
